/* Raw Elements — Conversion-Motion (TubeBridge 2026-08-07)
   L2 Warenkorb-Bestaetigung am ATC-Button + L3 Gratisversand-Fortschritt im
   Warenkorb-Drawer. Laeuft unabhaengig von prefers-reduced-motion.
   2026-08-07 (P2): directAddOnCards -> Karten-ATC one-click. */
(function () {
  'use strict';
  var THRESHOLD = 2900;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action^="/cart/add"]')) return;
    var btn = form.querySelector('button[type="submit"], .product-form__submit');
    if (!btn) return;
    btn.classList.add('re-added');
    setTimeout(function () { btn.classList.remove('re-added'); }, 1700);
  }, true);
  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  /* Kundenstimmen (#re-tstm-pdp, via theme.liquid ganz unten gerendert) direkt
     UNTER die Sektion "Wie unser Matcha entsteht" (.re-proz) einhaengen, wenn
     diese existiert. Sonst nichts tun -> Snippet bleibt unten. */
  function moveTestimonials() {
    var _t = document.getElementById('re-tstm-pdp');
    var _p = document.querySelector('.re-proz');
    if (_t && _p) { var _s = _p.closest('.shopify-section') || _p; if (_s.parentNode) _s.parentNode.insertBefore(_t, _s.nextSibling); }
  }
  /* Karten-ATC (2026-08-07): Klick auf "In den Warenkorb" einer Produktkarte
     legt die Default-Variante DIREKT in den Warenkorb (statt Quick-Buy-Drawer
     mit zweitem Klick) und oeffnet den Warenkorb-Drawer. Trifft nur Karten-
     Buttons (aria-controls="quick-buy..."); Produktseiten nutzen buy-buttons
     und bleiben unberuehrt. Ohne aufloesbare Variante -> natives Quick-Buy.
     Der Drawer wird per Shopify-Section-Rendering (sections:['cart-drawer'])
     frisch geladen, damit die neue Zeile sofort drinsteht. */
  function directAddOnCards() {
    document.addEventListener('click', function (e) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var btn = e.target.closest('[aria-controls^="quick-buy"]');
      if (!btn) return;
      var qb = document.getElementById(btn.getAttribute('aria-controls'));
      if (!qb) return;
      var m = (qb.getAttribute('handle') || '').match(/variant=(\d+)/);
      if (!m) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (btn.hasAttribute('disabled')) return;
      btn.setAttribute('disabled', '');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(m[1], 10), quantity: 1 }], sections: ['cart-drawer'], sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          btn.removeAttribute('disabled');
          if (!res.ok) return;
          var sec = res.data && res.data.sections && res.data.sections['cart-drawer'];
          if (sec) {
            var host = document.getElementById('shopify-section-cart-drawer');
            if (host) {
              var fresh = new DOMParser().parseFromString(sec, 'text/html').getElementById('shopify-section-cart-drawer');
              if (fresh) host.replaceWith(fresh);
            }
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          var opener = document.querySelector('[aria-controls="cart-drawer"]');
          if (opener) opener.click();
        })
        .catch(function () { btn.removeAttribute('disabled'); });
    }, true);
  }
  function render() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var inner = drawer.querySelector('.cart-drawer__inner') || drawer;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bar = drawer.querySelector('.re-freeship');
        if (!bar) {
          bar = document.createElement('div');
          bar.className = 're-freeship';
          bar.innerHTML = '<p class="re-freeship__txt"></p><div class="re-freeship__track"><span class="re-freeship__fill"></span></div>';
          var top = inner.querySelector('.cart-drawer__top');
          if (top && top.parentNode === inner) inner.insertBefore(bar, top.nextSibling);
          else inner.insertBefore(bar, inner.firstChild);
        }
        if (!cart.item_count) { bar.style.display = 'none'; return; }
        bar.style.display = '';
        var total = cart.total_price;
        var pct = Math.max(4, Math.min(100, Math.round((total / THRESHOLD) * 100)));
        var remain = THRESHOLD - total;
        bar.querySelector('.re-freeship__fill').style.width = pct + '%';
        var txt = bar.querySelector('.re-freeship__txt');
        if (remain <= 0) txt.innerHTML = 'Stark, du hast <strong>kostenlosen Versand</strong>';
        else txt.innerHTML = 'Nur noch <strong>' + money(remain) + '</strong> bis zum kostenlosen Versand';
      })
      .catch(function () {});
  }
  function boot() {
    moveTestimonials();
    directAddOnCards();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var mo = new MutationObserver(function () { if (!drawer.querySelector('.re-freeship')) render(); });
      mo.observe(drawer, { childList: true, subtree: true });
    }
    document.addEventListener('cart:refresh', render);
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.matches && e.target.matches('form[action^="/cart/add"]')) setTimeout(render, 1000);
    }, true);
    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();